import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-ag-entities-info-modal',
  templateUrl: './ag-entities-info-modal.component.html',
  styleUrls: ['./ag-entities-info-modal.component.scss']
})
export class AgEntitiesInfoModalComponent {

  constructor(
    public dialogRef: MatDialogRef<AgEntitiesInfoModalComponent>,
  ) { }

  closeModal(): void {
    this.dialogRef.close();
  }

}
